import { mainSiteUrl } from '@/mocks/siteData';

export default function CtaSection() {
  return (
    <section className="relative w-full py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
          Start Using Oopbuyspreadsheet Today
        </h2>
        <p className="text-base md:text-lg text-foreground-500 mb-8 max-w-xl mx-auto leading-relaxed">
          Join thousands of smart buyers who have transformed their purchasing workflow with the oopbuy spreadsheet system. Your journey to organized, profitable buying starts here.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-6">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            Download Free Template
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
          >
            Visit Main Platform
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>

      <div className="mt-16 flex items-center justify-center gap-6 md:gap-10 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Isolated%20product%20shot%20of%20cream%20leather%20sneaker%20floating%20on%20pure%20white%20background%2C%20studio%20lighting%2C%20clean%20professional%20product%20photography%2C%20minimalist%20ecommerce%20aesthetic%2C%20soft%20shadow%20beneath&width=300&height=300&seq=cta-v2-1-m7n&orientation=squarish"
          alt=""
          className="w-24 h-24 md:w-32 md:h-32 object-contain opacity-60"
        />
        <img
          src="https://readdy.ai/api/search-image?query=Isolated%20product%20shot%20of%20sage%20green%20cotton%20hoodie%20folded%20on%20pure%20white%20background%2C%20studio%20lighting%2C%20clean%20professional%20product%20photography%2C%20minimalist%20ecommerce%20aesthetic&width=300&height=300&seq=cta-v2-2-p4x&orientation=squarish"
          alt=""
          className="w-20 h-20 md:w-28 md:h-28 object-contain opacity-60"
        />
        <img
          src="https://readdy.ai/api/search-image?query=Isolated%20product%20shot%20of%20tan%20leather%20crossbody%20bag%20on%20pure%20white%20background%2C%20studio%20lighting%2C%20clean%20professional%20product%20photography%2C%20minimalist%20ecommerce%20aesthetic&width=300&height=300&seq=cta-v2-3-r8s&orientation=squarish"
          alt=""
          className="w-24 h-24 md:w-32 md:h-32 object-contain opacity-60"
        />
        <img
          src="https://readdy.ai/api/search-image?query=Isolated%20product%20shot%20of%20woven%20straw%20fedora%20hat%20on%20pure%20white%20background%2C%20studio%20lighting%2C%20clean%20professional%20product%20photography%2C%20minimalist%20ecommerce%20aesthetic%2C%20soft%20shadow&width=300&height=300&seq=cta-v2-4-t2q&orientation=squarish"
          alt=""
          className="w-20 h-20 md:w-28 md:h-28 object-contain opacity-60"
        />
        <img
          src="https://readdy.ai/api/search-image?query=Isolated%20product%20shot%20of%20amber%20glass%20perfume%20bottle%20with%20gold%20cap%20on%20pure%20white%20background%2C%20studio%20lighting%2C%20clean%20professional%20product%20photography%2C%20luxury%20minimalist%20aesthetic&width=300&height=300&seq=cta-v2-5-w9b&orientation=squarish"
          alt=""
          className="w-24 h-24 md:w-32 md:h-32 object-contain opacity-60"
        />
      </div>
    </section>
  );
}